import { toast } from 'react-toastify';

import { i18n } from '../../localization/i18n';

// Toasts raised while a pop-up is open go to its own container: a modal
// <dialog> sits in the top layer, above the app-wide container.
export const DIALOG_TOAST_CONTAINER = 'createChat';

/**
 * Error toast raised while a pop-up is still open.
 *
 * @param {string} message Text already translated.
 */
export const showDialogError = message => toast.error(message, { containerId: DIALOG_TOAST_CONTAINER });

/**
 * Offline toast (common rule 11, E35) for an action that needs the server.
 */
export const showOfflineError = () => showDialogError(i18n.t('common.INTERNET_ERROR_MESSAGE'));
